import type { MenuDataItem } from "@ant-design/pro-components";

export function enhanceNavigationMenu(
  items: MenuDataItem[],
  _locale = "zh-CN"
): MenuDataItem[] {
  return items.map((item) => {
    if (item.path === "/cloak") {
      return { ...item, children: undefined };
    }
    if (item.path === "/landing-page") {
      return {
        ...item,
        children: (item.children || []).map((child) =>
          child.path === "/landing-page/ai/list"
            ? { ...child, hideInMenu: false }
            : child
        ),
      };
    }
    return item;
  });
}

/** Keep hidden editors and document details attached to their visible navigation entry. */
export function getNavigationSelectedKeys(
  pathname: string
): string[] | undefined {
  if (/^\/docs\/.+/.test(pathname)) return ["/docs"];
  if (/^\/cloak(?:\/|$)/.test(pathname)) {
    return ["/cloak"];
  }
  if (/^\/landing-page\/ai\/(?:create|edit|clone)(?:\/|$)/.test(pathname))
    return ["/landing-page/ai"];
  if (/^\/landing-page\/edit\//.test(pathname)) return ["/landing-page/list"];
  return undefined;
}
